import { fromBase64 } from './base64';

const textDecoder = new TextDecoder();

export function decodeEncodedValue(encodedValue: string): string | null {
  try {
    const urlDecoded = decodeURIComponent(encodedValue);

    return textDecoder.decode(fromBase64(urlDecoded));
  } catch (error) {
    console.error('Error decoding value:', error);
    return null;
  }
}

export function encodeValue(value: string) {
  try {
    const base64Encoded = btoa(value);

    return encodeURIComponent(base64Encoded);
  } catch (error) {
    console.error('Error encoding value:', error);
    return null;
  }
}
